import SoundSortGame from "./SoundSortGame";
import SentenceBuilderGame from "./SentenceBuilderGame";
import LetterHuntGame from "./LetterHuntGame";
import CatchFallingGame from "./CatchFallingGame";
import PictureGridGame from "./PictureGridGame";
import BubblePopGame from "./BubblePopGame";
import GuidedTraceGame from "./GuidedTraceGame";
import PictureMatchGame from "./PictureMatchGame";
import StoryPagesGame from "./StoryPagesGame";
import DiscoveryGame from "./DiscoveryGame";
import CallSequenceGame from "./CallSequenceGame";
import WordBuilderGame from "./WordBuilderGame";
import StrokeAssemblyGame from "./StrokeAssemblyGame";
import MemoryPairGame from "./MemoryPairGame";
import SoundPairsGame from "./SoundPairsGame";
import SoundPositionGame from "./SoundPositionGame";
import SentenceMeaningGame from "./SentenceMeaningGame";
import GenericTapGame from "./GenericTapGame";

/** Map of letterGameConfigs `engine` keys → React components. */
export const ENGINE_MAP = {
  soundSort: SoundSortGame,
  sentenceBuilder: SentenceBuilderGame,
  letterHunt: LetterHuntGame,
  catchFalling: CatchFallingGame,
  pictureGrid: PictureGridGame,
  bubblePop: BubblePopGame,
  guidedTrace: GuidedTraceGame,
  pictureMatch: PictureMatchGame,
  storyPages: StoryPagesGame,
  discovery: DiscoveryGame,
  callSequence: CallSequenceGame,
  wordBuilder: WordBuilderGame,
  strokeAssembly: StrokeAssemblyGame,
  memoryPair: MemoryPairGame,
  soundPairs: SoundPairsGame,
  soundPosition: SoundPositionGame,
  sentenceMeaning: SentenceMeaningGame,
  genericTap: GenericTapGame,
};

export {
  SoundSortGame,
  SentenceBuilderGame,
  LetterHuntGame,
  CatchFallingGame,
  PictureGridGame,
  BubblePopGame,
  GuidedTraceGame,
  PictureMatchGame,
  StoryPagesGame,
  DiscoveryGame,
  CallSequenceGame,
  WordBuilderGame,
  StrokeAssemblyGame,
  MemoryPairGame,
  SoundPairsGame,
  SoundPositionGame,
  SentenceMeaningGame,
  GenericTapGame,
};

export default ENGINE_MAP;
